import { SwiperSlide } from 'swiper/react'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import { MagazineNode } from '@gql/graphql'
import { useTrans, useTransRoute } from '@hooks/index'
import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import { ArticoloCard } from '../../molecules'
import { GenericSlider, GenericSection } from '@components/organisms'
import styles from './ArticoliSection.module.sass'

interface Props {
  magazines?: MagazineNode[]
  item?: MenuItemType
  theme?: GenericSectionThemeType
  className?: string
}

const ArticoliSection = (props: Props) => {
  const { magazines = undefined, item = undefined, theme = 'white', className = '' } = props

  const t = useTrans()
  const tRoute = useTransRoute()

  return magazines?.length > 0 ? (
    <GenericSection
      item={{
        name: t('Articoli correlati'),
        ctaLabel: t('Vedi tutti gli articoli'),
        url: tRoute('/magazine')?.href,
        ...item, // Override
      }}
      theme={theme}
      className={`${styles.root} ${className}`}
    >
      <GenericSlider
        id="articoliswiper_slider"
        navigationPos="pagination"
        conf={{
          slidesPerView: 1.1,
          spaceBetween: 20,
          modules: [A11y, Navigation, Pagination],
          navigation: true,
          pagination: { clickable: true },
          breakpoints: {
            768: {
              slidesPerView: 2.2,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
        }}
        className={styles.slider}
      >
        {magazines.map((i) => (
          <SwiperSlide key={i.pk}>
            <ArticoloCard news={i} />
          </SwiperSlide>
        ))}
      </GenericSlider>
    </GenericSection>
  ) : (
    <></>
  )
}

export default ArticoliSection
